import {
  Component,
  ElementRef,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { UserLoginService } from "../login/userlogin.service";
import {
  SubRoleMenuDTO,
  SubRolesReadByUserIdRequestDTO,
} from "../SubRoles/SubRoles.interface";
import { LoaderService } from "../Shared Utilities/global-loader/loader.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { SubRolesService } from "../SubRoles/subrole.service";
import { UserMasterReadyByUserId } from "../master/users/users.interface";
import { UsersService } from "../master/users/users.service";
import { UserSharedService } from "../Shared Utilities/user-shared.service";
import { environment } from "src/environment/environment";
import {
  UserLoginDTO,
  UserLoginResponseDTO,
} from "../login/userlogin.interface";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { SchoolMasterService } from "../School/BackOffice/school-master/school-master.service";
import { SchoolImgMasterService } from "../School/BackOffice/school-img/school-img-master.service";
import { UserAffiliationMappingService } from "../School/SchoolUserMapping/user-affiliation-mapping.service";
import { HospitalImgMasterService } from "../hospital/BackOffice/hospital-master/hospital-detail/hospital-img/hospital-img.service";
import { HospitalImgMasterReadByMasterIdRequestDTO } from "../hospital/BackOffice/hospital-master/hospital-detail/hospital-img/hospital-img.interface";
import { HospitalUserAffiliationService } from "../hospital/HospitalUserMapping/user-affiliation-mapping.service";
import { HospitalUserAffiliationReadByUserIdRequestDTO } from "../hospital/HospitalUserMapping/user-affiliation-mapping.interface";
import { HospitalMasterService } from "../hospital/BackOffice/hospital-master/hospital-master.service";

// ============================================================
// MINIMUM ADDITION: Existing Common PrintMaster flow
// ============================================================
import { MasterPrintMasterServices } from "src/app/Common/PrintMaster/PrintMaster.service";
import { PrintMasterPrintDynamicSQLRequestDTO } from "src/app/Common/PrintMaster/PrintMaster.interface";
import { ToastrService } from "ngx-toastr";
import { HttpClient } from "@angular/common/http";
import { MenuMaster_readAll } from "src/app/GlobalVariable";

// ============================================================
// MINIMUM ADDITION:
// Exact frontend contract for backend PrintMaster GeneratePrint DTO
// ============================================================
interface PrintMasterGeneratePrintRequestDTO {
  moduleName: string;
  moduleId: string;
  templateId: string | null;
  headerHtml: string | null;
  customCss: string | null;
  footerHtml: string | null;
}

interface PrintMasterGeneratePrintResponseDTO {
  moduleName?: string | null;
  moduleId?: string | null;
  templateName?: string | null;
  pSeq: number;
  pContent?: string | null;
}

interface PrintMasterGeneratePrintList {
  items?: PrintMasterGeneratePrintResponseDTO[] | null;
}

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit, OnDestroy {
  UsersService = inject(UsersService);

  // ============================================================
  // MINIMUM ADDITION: Reuse existing PrintMaster API/service
  // ============================================================
  private masterPrintMasterService = inject(MasterPrintMasterServices);
  private toastr = inject(ToastrService);

  /*
   * MINIMUM ADDITION:
   * Used only for the dedicated GeneratePrint API and the existing
   * School PrintMaster ReadBySchoolId API.
   *
   * Existing app EncryptionInterceptor continues to encrypt/decrypt
   * these requests exactly like the other Angular API calls.
   */
  private http = inject(HttpClient);

  firstName = "";
  // ============================================================
// HEADER SEARCH - LIVE PREFIX FILTER
// ============================================================

headerSearchText: string = "";
showHeaderSearchResults: boolean = false;
filteredHeaderSearchResults: any[] = [];

private getHeaderSearchMenus(): SubRoleMenuDTO[] {
  const results: SubRoleMenuDTO[] = [];
  const visited = new Set<string>();

  const collect = (menus: SubRoleMenuDTO[]): void => {
    for (const item of menus || []) {
      const name = String(item.subRoleName || "").trim();
      const code = String(item.subRoleCode || "").trim();
      const key = `${item.menuId}:${code}`;

      if (name && !visited.has(key)) {
        visited.add(key);
        results.push(item);
      }
      


      if (item.childMenuList?.length) {
        collect(item.childMenuList);
      }
    }
  };

  collect(this.parentMenu);

  return results;
}


private readonly parentStudentTabs = [
  { name: 'Student Detail', tab: 'studentinfo' },
  { name: 'TimeTable', tab: 'timetable' },
  { name: 'Announcements & Events', tab: 'announcement-event' },
  { name: 'Assignment', tab: 'assignment' },
 { name: 'Fee Structure', tab: 'feedetail' },
  { name: 'Discussion', tab: 'discussion' },
  { name: 'Feedback', tab: 'feedback' },
  { name: 'Certificates & Kudos', tab: 'certificates-kudos' },
  { name: 'Exam Schedule', tab: 'exam-schedule' },
  { name: 'Student Mark Report', tab: 'student-mark-report' },
  { name: 'School Detail', tab: 'school-detail' },
  { name: 'My Tickets', tab: 'my-tickets' }
];

private getParentStudentSearchResults(query: string): any[] {
  if (!this.router.url.startsWith('/school-parent/spe-u-studentdetail')) {
    return [];
  }

  return this.parentStudentTabs
    .filter(item => item.name.toLowerCase().startsWith(query))
    .map(item => ({
      subRoleName: item.name,
      subRoleCode: item.tab,
      menuIconUrl: 'fas fa-search',
      isParentStudentTab: true
    }));
}

onHeaderSearchInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  this.headerSearchText = input.value;

  const query = this.headerSearchText.trim().toLowerCase();

  if (!query) {
    this.filteredHeaderSearchResults = [];
    this.showHeaderSearchResults = false;
    return;
  }

  const menuResults = this.getHeaderSearchMenus()
    .filter((item: SubRoleMenuDTO) => {
      const name = String(item.subRoleName || '').trim().toLowerCase();

      if (/^\d+$/.test(query)) {
        return String(item.menuId ?? '').startsWith(query);
      }

      return name.startsWith(query);
    });

  const tabResults = /^\d+$/.test(query)
    ? []
    : this.getParentStudentSearchResults(query);

  this.filteredHeaderSearchResults = [
    ...tabResults,
    ...menuResults
  ].slice(0, 20);

  this.showHeaderSearchResults = true;
}
onHeaderSearchFocus(): void {
  if (this.headerSearchText.trim()) {
    this.showHeaderSearchResults = true;
  }
}

closeHeaderSearch(): void {
  this.showHeaderSearchResults = false;
}

clearHeaderSearch(): void {
  this.headerSearchText = "";
  this.filteredHeaderSearchResults = [];
  this.showHeaderSearchResults = false;
}

selectHeaderSearchResult(item: any): void {

  if (item.isParentStudentTab) {

    const currentPath = this.router.url.split('?')[0];

    this.clearHeaderSearch();

    this.router.navigate([currentPath], {
      queryParams: {
        tab: item.subRoleCode
      }
    });

    return;
  }

  const link = this.getSidebarRouterLink(
    item,
    item.searchParentMenu
  );

  this.clearHeaderSearch();

  this.router.navigate(
    Array.isArray(link) ? link : [link],
    { relativeTo: this.activatedRoute }
  );
} 
  parentMenu: SubRoleMenuDTO[] = [];
  expandedMenus: { [key: number]: boolean } = {};

  
  // ============================================================
  // GLOBAL SEARCH - EXISTING ACCESSIBLE MENU/PAGE SEARCH
  // ============================================================

  appSearchQuery: string = "";
  appSearchFocused: boolean = false;

  get appSearchResults(): {
    title: string;
    parentName: string;
    icon: string;
    route: string | any[];
  }[] {

    const searchText = this.appSearchQuery.trim().toLowerCase();

    if (!searchText) {
      return [];
    }

    const results: {
      title: string;
      parentName: string;
      icon: string;
      route: string | any[];
    }[] = [];

    const addedRoutes = new Set<string>();

    const searchMenus = (menus: any[], parent?: any): void => {

      for (const menu of menus || []) {

        const children = Array.isArray(menu?.childMenuList)
          ? menu.childMenuList
          : [];

        const isActive = Number(menu?.isActive ?? 1) === 1;
        const isDeleted = Number(menu?.isDeleted ?? 0) === 1;

        if (!isActive || isDeleted) {
          continue;
        }

        const title = String(menu?.subRoleName || "").trim();
        const code = String(menu?.subRoleCode || "").trim();
        const parentName = parent
          ? String(parent?.subRoleName || "").trim()
          : "";

        const searchableText = `${title} ${code}`.toLowerCase();

        // Search actual pages, not expandable parent headings
       
if (
  children.length === 0 &&
  title &&
  title.toLowerCase().startsWith(searchText)
) {

          const route = this.getSidebarRouterLink(menu, parent);

          const routeKey = Array.isArray(route)
            ? route.join("/")
            : String(route || "");

          if (routeKey && !addedRoutes.has(routeKey)) {

            addedRoutes.add(routeKey);

            results.push({
              title: title,
              parentName: parentName,
              icon: menu?.menuIconUrl || "fas fa-file-alt",
              route: route
            });

          }
        }

        if (children.length > 0) {
          searchMenus(children, menu);
        }
      }
    };

    // Same menu tree that powers the visible sidebar
    searchMenus(this.parentMenu);
    
    // ============================================================
    // SCHOOL DETAILS INTERNAL TAB SEARCH
    // ============================================================

    const canAccessSchoolDetails = (menus: any[]): boolean => {

      return (menus || []).some((menu: any) => {

        const isActive = Number(menu?.isActive ?? 1) === 1;
        const isDeleted = Number(menu?.isDeleted ?? 0) === 1;

        if (!isActive || isDeleted) {
          return false;
        }

        const code = String(
          menu?.subRoleCode ??
          menu?.SubRoleCode ??
          ""
        ).trim().toLowerCase();

        const path = String(
          menu?.templatePath ??
          menu?.TemplatePath ??
          ""
        ).trim().toLowerCase();

        const hasAccess =
          code === "spe-school-detail" ||
          path.startsWith("/school-admin/spe-school-detail") ||
          (
            code === "school-admin" &&
            (menu?.childMenuList || []).some((child: any) => {

              const childCode = String(
                child?.subRoleCode ??
                child?.SubRoleCode ??
                ""
              ).toLowerCase();

              const childActive = Number(child?.isActive ?? 1) === 1;
              const childDeleted = Number(child?.isDeleted ?? 0) === 1;

              return childActive && !childDeleted &&
                (
                  childCode === "spe-school-detail" ||
                  childCode === "spe-school-dashboard"
                );
            })
          );

        return hasAccess ||
          canAccessSchoolDetails(menu?.childMenuList || []);
      });
    };

    if (canAccessSchoolDetails(this.parentMenu)) {

      const schoolInternalPages = [
        {
          title: "Staff List",
          keywords: "staff staff list teaching non teaching employee",
          tab: "staff"
        },
        {
          title: "Class",
          keywords: "class classes class listing",
          tab: "class"
        },
        {
          title: "Exam",
          keywords: "exam examination",
          tab: "exam"
        },
        {
          title: "Announcement",
          keywords: "announcement announcements notice",
          tab: "announcement"
        },
        {
          title: "Event",
          keywords: "event events",
          tab: "event"
        },
        {
          title: "Bank Details",
          keywords: "bank bank details account",
          tab: "bank"
        },
        {
          title: "Images",
          keywords: "image images photo gallery",
          tab: "img"
        },
        {
          title: "Documents",
          keywords: "document documents files",
          tab: "doc"
        },
        {
          title: "Vehicle List",
          keywords: "vehicle vehicles transport",
          tab: "vehicle"
        },
        {
          title: "Tickets",
          keywords: "ticket tickets support",
          tab: "ticket"
        }
      ];

      schoolInternalPages.forEach((page) => {

        
const searchableText = page.title.toLowerCase();

if (!searchableText.startsWith(searchText)) {
  return;
}


        const pageRoute =
          `/school-admin/spe-school-detail?tab=${page.tab}`;

        if (addedRoutes.has(pageRoute)) {
          return;
        }

        addedRoutes.add(pageRoute);

        results.push({
          title: page.title,
          parentName: "School Details",
          icon: "fas fa-school",
          route: pageRoute
        });

      });

    }

    // ============================================================
    // END SCHOOL DETAILS INTERNAL TAB SEARCH
    // ============================================================

    return results
      .sort((a, b) => {

        const aStarts = a.title.toLowerCase().startsWith(searchText) ? 0 : 1;
        const bStarts = b.title.toLowerCase().startsWith(searchText) ? 0 : 1;

        if (aStarts !== bStarts) {
          return aStarts - bStarts;
        }

        return a.title.localeCompare(b.title);
      })
      .slice(0, 10);
  }

  onAppSearchInput(event: Event): void {

    const input = event.target as HTMLInputElement;

    this.appSearchQuery = input.value;
    this.appSearchFocused = true;
  }

  onAppSearchEnter(event: KeyboardEvent): void {

    event.preventDefault();

    const firstResult = this.appSearchResults[0];

    if (!firstResult) {
      return;
    }

    this.openAppSearchResult(firstResult.route);
  }

  
  openAppSearchResult(route: string | any[]): void {

    if (typeof route === "string") {

      const targetUrl = route.startsWith("/")
        ? route
        : "/" + route;

      this.router.navigateByUrl(targetUrl);

    } else {

      this.router.navigate(route);

    }

    this.closeAppSearch();
  }


  closeAppSearch(): void {

    this.appSearchQuery = "";
    this.appSearchFocused = false;
  }

  @HostListener("document:click", ["$event"])
  onAppSearchOutsideClick(event: MouseEvent): void {

    const target = event.target as Element;

    if (target && !target.closest(".global-app-search")) {
      this.appSearchFocused = false;
    }
  }

  // ============================================================
  // END GLOBAL SEARCH
  // ============================================================


  constructor(
    private router: Router,
    public userloginService: UserLoginService,
    private loader: LoaderService,
    private subRolesService: SubRolesService,
    private activatedRoute: ActivatedRoute,
    private userShared: UserSharedService,
    private schoolMasterService: SchoolMasterService,
    private schoolImgService: SchoolImgMasterService,
    private schoolUserMappingService: UserAffiliationMappingService,
    private hospitalImgService: HospitalImgMasterService,
    private hospitalUserAffiliationService: HospitalUserAffiliationService,
    private hospitalMasterService: HospitalMasterService
  ) {}

  isDropdownOpen = false;
  showERPIcons: boolean = true;

  isUserReady: boolean = false;

  schoolBrandName: string = "";
  schoolBrandLogo: string = "";
  schoolBrandLogoFailed: boolean = false;

  hospitalBrandName: string = "";
  hospitalBrandLogo: string = "";
  hospitalBrandLogoFailed: boolean = false;

  // ============================================================
  // MINIMUM ADDITION: SCHOOL CERTIFICATE GENERATOR
  // ============================================================
  showGenerateCertificatePopup: boolean = false;

  isCertificateSchoolLoading: boolean = false;
  isCertificateTemplateLoading: boolean = false;
  isCertificateGenerating: boolean = false;

  certificateSchoolList: any[] = [];
  certificateTemplateList: string[] = [];

  selectedCertificateSchoolId: number = 0;
  certificateTemplateId: string = "";

  /*
   * MINIMUM ADDITION:
   * Generic API-driven certificate context.
   *
   * Existing school fields above are intentionally kept so no existing
   * working code/flow is removed. They are synchronized when School is
   * selected.
   */
  isCertificateEntityLoading: boolean = false;

  /*
   * No Module dropdown is shown.
   * This value is automatically resolved from the current route:
   * School / Hospital / Society.
   */
  certificateSelectedModuleName: string = "";

  certificateEntityList: any[] = [];
  selectedCertificateEntityId: number = 0;

  /*
   * These three fields map exactly to dbo.GeneratePrint:
   *
   * @HeaderHtml
   * @CustomCss
   * @FooterHtml
   */
  certificateHeaderHtml: string = "";
  certificateCustomCss: string = "";
  certificateFooterHtml: string = "";

  generatedCertificateHtml: string = "";

  /*
   * IMPORTANT:
   * Tokens stay in TS strings, not raw Angular HTML attributes,
   * so Angular does not try to resolve {{SchoolName}} as a property.
   */
  readonly certificateHeaderPlaceholder: string =
    '<div class="certificate-header">\n' +
    '  <h2>{{SchoolName}}</h2>\n' +
    '  <p>{{SchoolAddress}}, {{City}}, {{State}} - {{Pincode}}</p>\n' +
    '</div>';

  readonly certificateCssPlaceholder: string =
    'body { font-family: Arial, sans-serif; }\n' +
    '.certificate-header { text-align: center; }';

  readonly certificateFooterPlaceholder: string =
    '<div class="certificate-footer">\n' +
    '  <p>Authorized Signatory</p>\n' +
    '</div>';

  private destroy$ = new Subject<void>();
  private schoolBrandRequestId = 0;

  // Hospital dashboard role-specific sidebar.
  // Keep the complete user menu untouched and only filter the visible sidebar.
  private allUserMenuItems: SubRoleMenuDTO[] = [];

  // ============================================================
  // MINIMUM FIX: FULL LOGIN GLOBAL MENU TREE
  // ============================================================
  // RoleId = 1 must continue showing every root module (School, Hospital,
  // Society, etc.) while also having the real MenuMaster child hierarchy.
  // Do not replace this global tree when the user enters Hospital.
  private fullLoginMenuMasterItems: any[] = [];
  private isFullLoginMenuMasterLoading = false;

  // Keep the original Full Login identity for the complete HomeComponent life.
  // Hospital role/dashboard code must never convert the global RoleId=1 sidebar
  // into a Hospital-only sidebar after navigation.
  private isFullLoginSession: boolean = false;

  private hospitalMenuRequestId = 0;

  // ============================================================
  // MINIMUM FIX: PERSIST FULL LOGIN ACROSS HOSPITAL REFRESH
  // ============================================================
  // When Full Login enters Hospital, the validated token can expose the
  // active Hospital role (for example RoleId 9) after refresh. Keep one
  // session-level flag so the global sidebar is not converted to Hospital-only.
  private readonly FULL_LOGIN_SESSION_KEY =
    "nishwik_full_login_session";

  // MINIMUM FIX: preserve only the sidebar scroll position.
  // No route, permission or existing menu data is changed.
  private sidebarMenuScrollTop: number = 0;
  private readonly SIDEBAR_SCROLL_POSITION_KEY =
    "nishwik_sidebar_scroll_top";

  private readonly HOSPITAL_ACTIVE_DASHBOARD_ROLE_KEY =
    "hospital_active_dashboard_role_id";

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @ViewChild("profileIcon") profileIcon!: ElementRef;
  @ViewChild("dropdownMenu") dropdownMenu!: ElementRef;

  // MINIMUM FIX: keep the left sidebar at the same scroll position
  // while navigating to menus that are lower in the list.
  @ViewChild("sidebarMenuScroll")
  sidebarMenuScroll?: ElementRef<HTMLElement>;

  userLoginService = inject(UserLoginService);

  User: any = this.userLoginService.User();

  redirectURL: string = environment.erpRedirectURL;

  ngOnInit(): void {
    // Restore Full Login before any NavigationEnd handler can apply
    // Hospital role-specific filtering during a browser refresh.
    this.isFullLoginSession =
      sessionStorage.getItem(this.FULL_LOGIN_SESSION_KEY) === "1";

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.refreshSchoolBrand();
        this.refreshHospitalLogo();

        // When Admin / Owner / Doctor dashboard changes,
        // immediately refresh only the visible sidebar for that role.
        this.applyHospitalDashboardSidebarMenu();

        // MINIMUM FIX: route navigation must not jump the left menu to top.
        this.restoreSidebarScrollPosition();
      });

    if (this.userloginService.isAuthenticated()) {
      this.loader.show();

      this.userloginService.UserLogin_ValidateToken().subscribe({
        next: (res) => {
          this.userLoginService.saveUserData(res);

          this.User = res;
          this.isUserReady = true;

          // IMPORTANT:
          // Do not overwrite an already-known Full Login with false here.
          // After entering Hospital, ValidateToken can return the active
          // Hospital role even though this browser session started as Full Login.
          const validatedRoleId = Number(
            (res as any)?.roleId ??
            (res as any)?.RoleId ??
            0
          );

          if (validatedRoleId === 1) {
            this.isFullLoginSession = true;
            sessionStorage.setItem(
              this.FULL_LOGIN_SESSION_KEY,
              "1"
            );
          }

          this.refreshSchoolBrand();
          this.refreshHospitalLogo();

          this.UsersService.UserMaster_ReadByUserId({
            userId: res.userId,
          }).subscribe({
            next: (userRes) => {
              this.userShared.setFirstName(userRes.firstName);
            },
            error: (err) => {
              console.error("Error fetching user details:", err);
              this.userShared.setFirstName("");
            },
          });

          const body: SubRolesReadByUserIdRequestDTO = { userId: res.userId };

          this.subRolesService
            .SubRoles_readByUserId(body)
            .subscribe((userMenu) => {
              const allMenuItems = userMenu?.items ?? [];

              let menulist = allMenuItems.map((res) => res.subRoleCode);
              localStorage.setItem("menuList", menulist.toString());

              // Keep the user's complete permission/menu result exactly as before.
              // We only use a filtered copy for the hospital sidebar display.
              this.allUserMenuItems = allMenuItems;
              this.parentMenu = this.buildMenuTree(allMenuItems);
              this.restoreSidebarScrollPosition();

              // MINIMUM REFRESH FIX:
              // On Full Login -> Hospital -> browser refresh, ValidateToken can
              // report the active Hospital RoleId. ReadByUserId still contains
              // the global application menu, so use that existing result as a
              // second safe signal and persist it for the current browser tab.
              if (
                !this.isFullLoginSession &&
                this.isFullLoginGlobalMenu(allMenuItems)
              ) {
                this.isFullLoginSession = true;
                sessionStorage.setItem(
                  this.FULL_LOGIN_SESSION_KEY,
                  "1"
                );
              }

              this.showERPIcons = this.isFullLoginSession;

              // Full Login must use MenuMaster as the hierarchy source so all
              // root modules remain visible and their child menus can expand.
              // Normal users keep the existing ReadByUserId flow unchanged.
              if (this.isFullLoginSession) {
                this.loadFullLoginMenuMaster();
              } else {
                // If the current page is an Owner/Admin/Doctor hospital context,
                // show only that role's mapped sidebar menu.
                this.applyHospitalDashboardSidebarMenu();
              }

              this.loader.dismiss();
            });

          this.showERPIcons = this.isFullLoginSession;
        },
        error: () => {
          this.isUserReady = false;
          this.isFullLoginSession = false;
          sessionStorage.removeItem(this.FULL_LOGIN_SESSION_KEY);
          this.resetSchoolBrand();
          this.resetHospitalBrand();
          this.loader.dismiss();
          this.userloginService.SignOutUser();
        },
      });
    } else {
      this.isUserReady = false;
      this.isFullLoginSession = false;
      sessionStorage.removeItem(this.FULL_LOGIN_SESSION_KEY);
      this.resetSchoolBrand();
      this.resetHospitalBrand();
      this.userloginService.SignOutUser();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get shouldShowSchoolBrand(): boolean {
    return this.isSchoolModuleRoute() && !!this.schoolBrandName;
  }

  get schoolBrandInitial(): string {
    return (this.schoolBrandName || "S").trim().charAt(0).toUpperCase();
  }

  get shouldShowHospitalBrand(): boolean {
    return (
      this.isHospitalModuleRoute() &&
      (!!this.hospitalBrandName || !!this.hospitalBrandLogo)
    );
  }

  get hospitalBrandInitial(): string {
    return (this.hospitalBrandName || "H")
      .trim()
      .charAt(0)
      .toUpperCase();
  }

  // ============================================================
  // MINIMUM ADDITION:
  // Generate Certificate only on exact School Listing route.
  // ============================================================
  get isSchoolMasterListingRoute(): boolean {
    const currentUrl = String(
      this.router.url ||
      window.location.pathname ||
      ""
    )
      .split("?")[0]
      .split("#")[0]
      .trim()
      .toLowerCase()
      .replace(/\/+$/, "");

    return currentUrl === "/school/school-master";
  }

  /*
   * MINIMUM FIX ONLY:
   * Generate Certificate must remain visible for Full Login.
   *
   * Existing showERPIcons uses roleId === 1, but some validated-user
   * responses can make that flag false even when the current login has
   * the full application menu. Therefore we keep the existing rule and
   * add safe fallbacks without changing login/menu flow.
   */
  get isFullLoginForGenerateCertificate(): boolean {
    const currentUser: any =
      this.User ||
      this.userLoginService.User();

    const roleId = Number(
      currentUser?.roleId ??
      currentUser?.RoleId ??
      0
    );

    if (this.showERPIcons || roleId === 1) {
      return true;
    }

    /*
     * Full-login menu fallback:
     * the current full login has the global Menu Master permission.
     * This is only used for button visibility; no permission/menu data
     * is modified.
     */
    return (this.parentMenu || []).some((menu: any) => {
      const menuText = String(
        menu?.subRoleName ??
        menu?.SubRoleName ??
        menu?.subRoleCode ??
        menu?.SubRoleCode ??
        ""
      )
        .trim()
        .toLowerCase();

      return (
        menuText === "menu master" ||
        menuText.includes("menu-master") ||
        menuText.includes("menumaster")
      );
    });
  }

  /*
   * MINIMUM FIX:
   * The same Generate Certificate button is available while the user is
   * inside School, Hospital or Housing Society modules.
   *
   * No existing route or navigation is changed.
   */
  get isGenerateCertificateSupportedRoute(): boolean {
    const currentUrl = String(
      this.router.url ||
      window.location.pathname ||
      ""
    )
      .split("?")[0]
      .split("#")[0]
      .trim()
      .toLowerCase();

    return (
      currentUrl.includes("/school") ||
      currentUrl.includes("/school-admin") ||
      currentUrl.includes("/spe-") ||
      currentUrl.includes("/hospital") ||
      currentUrl.includes("/hm-") ||
      currentUrl.includes("/housing-society") ||
      currentUrl.includes("/society") ||
      currentUrl.includes("/sm-")
    );
  }

  private refreshSchoolBrand(): void {
    if (!this.isSchoolModuleRoute()) {
      this.resetSchoolBrand();
      return;
    }

    const userId = Number(this.User?.userId || 0);

    if (!userId) {
      this.resetSchoolBrand();
      return;
    }

    this.loadSchoolBrandByUserId(userId);
  }

  private isSchoolModuleRoute(): boolean {
    const currentUrl = this.router.url || window.location.pathname || "";

    return (
      currentUrl.includes("/school") ||
      currentUrl.includes("/school-admin") ||
      currentUrl.includes("/spe-")
    );
  }

  private loadSchoolBrandByUserId(userId: number): void {
    if (!userId) {
      this.resetSchoolBrand();
      return;
    }

    if (!this.isSchoolModuleRoute()) {
      this.resetSchoolBrand();
      return;
    }

    const requestId = ++this.schoolBrandRequestId;
    const body = { userId: userId };

    const routeSchoolId = this.getSchoolIdFromCurrentRoute();

    this.schoolUserMappingService.UserAffiliationMapping_ReadByUserId(body).subscribe({
      next: (res: any) => {
        if (requestId !== this.schoolBrandRequestId) {
          return;
        }

        const selectedMapping = this.getBestSchoolMappingFromUam(res, routeSchoolId);
        const mapping = this.extractNestedSchoolObject(selectedMapping);

        // ✅ Important fix:
        // Route schoolId gets first priority because parent/student pages can have many UAM mappings.
        // Earlier first UAM mapping was taking wrong school name.
        const schoolId =
          routeSchoolId ||
          this.getSchoolIdFromObject(mapping) ||
          this.getSchoolIdFromObject(selectedMapping);

        if (schoolId) {
          this.loadSchoolMasterBrandBySchoolId(
            schoolId,
            requestId,
            mapping || selectedMapping
          );
          return;
        }

        const directBrandApplied =
          this.applySchoolBrandFromSource(mapping) ||
          this.applySchoolBrandFromSource(selectedMapping);

        if (!directBrandApplied) {
          this.resetSchoolBrand();
        }
      },
      error: (err) => {
        console.error("Error fetching school brand from UAM ReadByUserId:", err);

        if (routeSchoolId) {
          this.loadSchoolMasterBrandBySchoolId(routeSchoolId, requestId, null);
        } else {
          this.resetSchoolBrand();
        }
      },
    });
  }

  private loadSchoolMasterBrandBySchoolId(
    schoolId: number,
    requestId: number,
    fallbackSource: any
  ): void {
    if (!schoolId) {
      if (!this.applySchoolBrandFromSource(fallbackSource)) {
        this.resetSchoolBrand();
      }
      return;
    }

    this.schoolMasterService.SchoolMaster_ReadById({
      schoolId: Number(schoolId),
    }).subscribe({
      next: (schoolRes: any) => {
        if (requestId !== this.schoolBrandRequestId) {
          return;
        }

        const school = this.getFirstResponseItem(schoolRes);

        const brandApplied =
          this.applySchoolBrandFromSource(school) ||
          this.applySchoolBrandFromSource(fallbackSource);

        if (!brandApplied) {
          this.resetSchoolBrand();
          return;
        }

        this.loadSchoolLogoBySchoolId(Number(schoolId), requestId);
      },
      error: (err) => {
        console.error("Error fetching school details for brand:", err);

        const brandApplied = this.applySchoolBrandFromSource(fallbackSource);

        if (brandApplied) {
          this.loadSchoolLogoBySchoolId(Number(schoolId), requestId);
        } else {
          this.resetSchoolBrand();
        }
      },
    });
  }

  private loadSchoolLogoBySchoolId(schoolId: number, requestId: number): void {
    if (!schoolId) {
      return;
    }

    this.schoolImgService
      .SchoolImgMaster_ReadByMasterType({ masterType: "School" })
      .subscribe({
        next: (imgRes: any) => {
          if (requestId !== this.schoolBrandRequestId) {
            return;
          }

          const imageList = Array.isArray(imgRes?.items)
            ? imgRes.items
            : Array.isArray(imgRes)
              ? imgRes
              : [];

          const schoolImages = imageList.filter(
            (img: any) =>
              Number(img?.masterId || img?.MasterId || 0) === Number(schoolId)
          );

          const defaultImg =
            schoolImages.find(
              (img: any) =>
                img?.isDefault === 1 ||
                img?.isDefault === true ||
                img?.IsDefault === 1 ||
                img?.IsDefault === true
            ) || schoolImages[0];

          const logoPath = this.getFirstAvailableString(defaultImg, [
            "imgPath",
            "ImgPath",
            "imagePath",
            "ImagePath",
            "logoPath",
            "LogoPath",
            "url",
            "URL",
          ]);

          const finalLogoUrl = this.normalizeSchoolLogoUrl(logoPath);

          if (finalLogoUrl) {
            this.schoolBrandLogo = finalLogoUrl;
            this.schoolBrandLogoFailed = false;
          }
        },
        error: (err) => {
          console.error("Error fetching school logo image:", err);
        },
      });
  }

  private getFirstResponseItem(response: any): any {
    if (!response) {
      return null;
    }

    if (Array.isArray(response)) {
      return response.length ? response[0] : null;
    }

    if (Array.isArray(response.items)) {
      return response.items.length ? response.items[0] : null;
    }

    if (Array.isArray(response.data)) {
      return response.data.length ? response.data[0] : null;
    }

    if (Array.isArray(response.result)) {
      return response.result.length ? response.result[0] : null;
    }

    if (response.item) {
      return response.item;
    }

    if (response.data && typeof response.data === "object") {
      return response.data;
    }

    if (response.result && typeof response.result === "object") {
      return response.result;
    }

    return response;
  }

  private extractNestedSchoolObject(mapping: any): any {
    if (!mapping || typeof mapping !== "object") {
      return null;
    }

    return (
      mapping.school ||
      mapping.School ||
      mapping.schoolMaster ||
      mapping.SchoolMaster ||
      mapping.schoolDetail ||
      mapping.SchoolDetail ||
      mapping.schoolDetails ||
      mapping.SchoolDetails ||
      mapping.affiliation ||
      mapping.Affiliation ||
      mapping.affiliationDetail ||
      mapping.AffiliationDetail ||
      mapping.affiliationDetails ||
      mapping.AffiliationDetails ||
      mapping.institution ||
      mapping.Institution ||
      mapping.institutionDetail ||
      mapping.InstitutionDetail ||
      mapping
    );
  }

  private applySchoolBrandFromSource(source: any): boolean {
    if (!source || typeof source !== "object") {
      return false;
    }

    const schoolName = this.getFirstAvailableString(source, [
      "schoolName",
      "SchoolName",
      "affiliationName",
      "AffiliationName",
      "institutionName",
      "InstitutionName",
      "instituteName",
      "InstituteName",
      "organizationName",
      "OrganizationName",
      "name",
      "Name",
      "otherDetail1",
      "OtherDetail1",
    ]);

    const logoPath = this.getFirstAvailableString(source, [
      "imgPath",
      "ImgPath",
      "schoolLogo",
      "SchoolLogo",
      "schoolLogoUrl",
      "SchoolLogoUrl",
      "logoPath",
      "LogoPath",
      "logoUrl",
      "LogoUrl",
      "imagePath",
      "ImagePath",
      "imageUrl",
      "ImageUrl",
      "profileImage",
      "ProfileImage",
      "otherDetail2",
      "OtherDetail2",
    ]);

    if (schoolName) {
      this.schoolBrandName = schoolName;
    }

    const finalLogoUrl = this.normalizeSchoolLogoUrl(logoPath);

    if (finalLogoUrl) {
      this.schoolBrandLogo = finalLogoUrl;
      this.schoolBrandLogoFailed = false;
    }

    return !!this.schoolBrandName;
  }

  private getSchoolIdFromObject(source: any): number {
    return this.getFirstAvailableNumber(source, [
      "schoolId",
      "SchoolId",
      "affiliationId",
      "AffiliationId",
      "masterId",
      "MasterId",
      "institutionId",
      "InstitutionId",
      "instituteId",
      "InstituteId",
      "organizationId",
      "OrganizationId",
    ]);
  }

  private getSchoolIdFromCurrentRoute(): number {
    let route: any = this.activatedRoute.snapshot;
    let foundValue = "";

    while (route) {
      const value =
        route.paramMap?.get("schoolId") ||
        route.paramMap?.get("SchoolId") ||
        route.paramMap?.get("id") ||
        route.queryParamMap?.get("schoolId") ||
        route.queryParamMap?.get("SchoolId");

      if (value) {
        foundValue = value;
      }

      route = route.firstChild;
    }

    if (foundValue && !isNaN(Number(foundValue))) {
      return Number(foundValue);
    }

    const currentUrl = this.router.url || window.location.pathname || "";

    const schoolParentStudentDetailMatch = currentUrl.match(
      /\/school-parent\/spe-u-studentdetail\/\d+\/(\d+)(?:\/|\?|$)/i
    );
    if (schoolParentStudentDetailMatch?.[1]) {
      return Number(schoolParentStudentDetailMatch[1]);
    }

    const speStudentDetailMatch = currentUrl.match(
      /\/spe-u-studentdetail\/\d+\/(\d+)(?:\/|\?|$)/i
    );
    if (speStudentDetailMatch?.[1]) {
      return Number(speStudentDetailMatch[1]);
    }

    const schoolMasterMatch = currentUrl.match(/\/school\/school-master\/(\d+)/i);
    if (schoolMasterMatch?.[1]) {
      return Number(schoolMasterMatch[1]);
    }

    const schoolIdQueryMatch = currentUrl.match(/[?&]schoolId=(\d+)/i);
    if (schoolIdQueryMatch?.[1]) {
      return Number(schoolIdQueryMatch[1]);
    }

    return 0;
  }

  private getResponseItems(response: any): any[] {
    if (!response) {
      return [];
    }

    if (Array.isArray(response)) {
      return response;
    }

    if (Array.isArray(response.items)) {
      return response.items;
    }

    if (Array.isArray(response.data)) {
      return response.data;
    }

    if (Array.isArray(response.result)) {
      return response.result;
    }

    if (response.item) {
      return [response.item];
    }

    if (response.data && typeof response.data === "object") {
      return [response.data];
    }

    if (response.result && typeof response.result === "object") {
      return [response.result];
    }

    return [response];
  }

  private getBestSchoolMappingFromUam(response: any, routeSchoolId: number): any {
    const mappingList = this.getResponseItems(response);

    if (!mappingList.length) {
      return null;
    }

    // ✅ First priority: match URL schoolId
    if (routeSchoolId) {
      const routeMatchedMapping = mappingList.find(
        (mapping: any) =>
          Number(mapping?.schoolId || mapping?.SchoolId || 0) ===
          Number(routeSchoolId)
      );

      if (routeMatchedMapping) {
        return routeMatchedMapping;
      }
    }

    // ✅ Second priority: primary school mapping
    const primaryMapping = mappingList.find(
      (mapping: any) =>
        Number(mapping?.isPrimary || mapping?.IsPrimary || 0) === 1
    );

    if (primaryMapping) {
      return primaryMapping;
    }

    // ✅ Last fallback: first mapping
    return mappingList[0];
  }

  private getFirstAvailableString(source: any, keys: string[]): string {
    if (!source || typeof source !== "object") {
      return "";
    }

    for (const key of keys) {
      const value = source[key];

      if (value !== null && value !== undefined && String(value).trim() !== "") {
        return String(value).trim();
      }
    }

    return "";
  }

  private getFirstAvailableNumber(source: any, keys: string[]): number {
    if (!source || typeof source !== "object") {
      return 0;
    }

    for (const key of keys) {
      const value = source[key];

      if (value !== null && value !== undefined && String(value).trim() !== "") {
        const numberValue = Number(value);

        if (!isNaN(numberValue) && numberValue > 0) {
          return numberValue;
        }
      }
    }

    return 0;
  }

  private normalizeSchoolLogoUrl(logoPath: string): string {
    if (!logoPath) {
      return "";
    }

    const value = String(logoPath).trim().replace(/\\/g, "/");

    if (!value) {
      return "";
    }

    if (
      value.startsWith("http://") ||
      value.startsWith("https://") ||
      value.startsWith("data:image/")
    ) {
      return value;
    }

    if (value.startsWith("assets/")) {
      return value;
    }

    const schoolRootUrl = String(environment.speApiURL || "").replace(/\/$/, "");

    if (!schoolRootUrl) {
      return value;
    }

    if (value.startsWith("/")) {
      return `${schoolRootUrl}${value}`;
    }

    return `${schoolRootUrl}/${value}`;
  }

  onSchoolBrandLogoError(): void {
    this.schoolBrandLogoFailed = true;
    this.schoolBrandLogo = "";
  }

  private resetSchoolBrand(): void {
    this.schoolBrandName = "";
    this.schoolBrandLogo = "";
    this.schoolBrandLogoFailed = false;
  }

  // ============================================================
  // MINIMUM FIX: FULL LOGIN GLOBAL MENU TREE
  // ============================================================

  private loadFullLoginMenuMaster(): void {

  if (!this.isFullLoginSession) {
    return;
  }

  if (this.isFullLoginMenuMasterLoading) {
    return;
  }


  /*
    MenuMaster_ReadAll API removed.

    Earlier flow:
    Full Login
        ->
    MenuMaster_ReadAll API
        ->
    Build sidebar

    Issue:
    MenuMaster_ReadAll was returning 404.

    New flow:
    Full Login
        ->
    Existing SubRoles_ReadByUserId data
        ->
    Build sidebar

    No existing permission/menu flow changed.
  */


  this.isFullLoginMenuMasterLoading = true;


  // Remove old MenuMaster data
  this.fullLoginMenuMasterItems = [];


  // Use existing loaded menu items
  this.parentMenu = this.buildMenuTree(
    this.allUserMenuItems
  );


  this.isFullLoginMenuMasterLoading = false;


  // Preserve sidebar scroll position
  this.restoreSidebarScrollPosition();

}

  /**
   * MenuMaster_ReadAll returns MenuName/MenuCode, while the existing sidebar
   * binds SubRoleName/SubRoleCode. Normalize only for rendering; no backend
   * data or existing flow is changed.
   */
  private normalizeMenuMasterForSidebar(item: any): any {
    return {
      ...item,
      subRoleId: Number(
        item?.subRoleId ?? item?.SubRoleId ?? item?.menuId ?? item?.MenuId ?? 0
      ),
      roleId: 1,
      subRoleName: String(
        item?.subRoleName ?? item?.SubRoleName ?? item?.menuName ?? item?.MenuName ?? ""
      ),
      subRoleCode: String(
        item?.subRoleCode ?? item?.SubRoleCode ?? item?.menuCode ?? item?.MenuCode ?? ""
      ),
      subRoleDesc: String(
        item?.subRoleDesc ?? item?.SubRoleDesc ?? item?.menuDesc ?? item?.MenuDesc ?? ""
      ),
      menuId: Number(item?.menuId ?? item?.MenuId ?? 0),
      displayOrder: Number(item?.displayOrder ?? item?.DisplayOrder ?? 0),
      parentMenuId: Number(item?.parentMenuId ?? item?.ParentMenuId ?? 0),
      defaultChildMenuId: Number(
        item?.defaultChildMenuId ?? item?.DefaultChildMenuId ?? 0
      ),
      menuIconUrl: String(item?.menuIconUrl ?? item?.MenuIconUrl ?? ""),
      templatePath: String(item?.templatePath ?? item?.TemplatePath ?? ""),
      isActive: Number(item?.isActive ?? item?.IsActive ?? 1),
      isDeleted: Number(item?.isDeleted ?? item?.IsDeleted ?? 0),
      moduleName: String(item?.moduleName ?? item?.ModuleName ?? ""),
      moduleId: Number(item?.moduleId ?? item?.ModuleId ?? 0),
      childMenuList: [],
    };
  }

  /**
   * Returns the correct base menu source without changing existing permission
   * logic for normal users.
   */
  private getBaseSidebarMenuItems(): SubRoleMenuDTO[] {
    if (
      this.isFullLoginSession &&
      this.fullLoginMenuMasterItems.length > 0
    ) {
      return this.fullLoginMenuMasterItems as SubRoleMenuDTO[];
    }

    return this.allUserMenuItems;
  }

  /**
   * Detects the existing Full Login global menu without changing any
   * permission/API flow. This is only a fallback for browser refreshes where
   * ValidateToken exposes the currently selected Hospital role.
   *
   * A normal Hospital/School/Society login will not have this combination of
   * application modules + global administration menus.
   */
  private isFullLoginGlobalMenu(menuItems: any[]): boolean {
    if (!Array.isArray(menuItems) || !menuItems.length) {
      return false;
    }

    const menuTexts = menuItems.map((menu: any) =>
      [
        menu?.subRoleName,
        menu?.SubRoleName,
        menu?.subRoleCode,
        menu?.SubRoleCode,
        menu?.templatePath,
        menu?.TemplatePath,
      ]
        .filter((value) => value !== null && value !== undefined)
        .join(" ")
        .trim()
        .toLowerCase()
    );

    const containsAny = (terms: string[]): boolean =>
      menuTexts.some((text: string) =>
        terms.some((term: string) => text.includes(term))
      );

    const moduleGroups: string[][] = [
      ["bbps"],
      ["paylater", "pay later"],
      ["real-estate", "real estate"],
      ["housing-society", "housing society", "society"],
      ["school"],
      ["hospital"],
      ["smartvault", "smart vault"],
      ["invest"],
      ["loan-leads", "loan leads"],
    ];

    const globalAdminGroups: string[][] = [
      ["menu master", "menumaster"],
      ["service availability", "service-availability"],
      ["module config", "module-config"],
      ["generate certificate", "generate-certificate"],
      ["crm"],
    ];

    const moduleMatchCount = moduleGroups.filter((group) =>
      containsAny(group)
    ).length;

    const globalAdminMatchCount = globalAdminGroups.filter((group) =>
      containsAny(group)
    ).length;

    // Full Login in your current menu has several application modules and
    // several global administration entries. Requiring both prevents normal
    // Hospital/Admin users from being treated as Full Login.
    return moduleMatchCount >= 3 && globalAdminMatchCount >= 2;
  }

  // ============================================================
  // HOSPITAL DASHBOARD ROLE-SPECIFIC SIDEBAR
  // ============================================================

  private normalizeHospitalDashboardRoute(route: string): string {
    return String(route || "")
      .split("?")[0]
      .split("#")[0]
      .trim()
      .toLowerCase()
      .replace(/\/+$/, "");
  }

  private isHospitalAttendanceManagementMenu(menu: any): boolean {
    const values = [
      menu?.subRoleName,
      menu?.SubRoleName,
      menu?.subRoleDesc,
      menu?.SubRoleDesc,
      menu?.subRoleCode,
      menu?.SubRoleCode,
      menu?.templatePath,
      menu?.TemplatePath,
    ]
      .filter((value) => value !== null && value !== undefined)
      .map((value) => String(value).trim().toLowerCase());

    return values.some(
      (value) =>
        value === "attendance management" ||
        value.includes("attendance management") ||
        value.includes("attendance-management") ||
        value.includes("hm-attendance"),
    );
  }

  /**
   * Dashboard route is authoritative.
   * On child hospital pages we retain the most recently selected dashboard role.
   *
   * 32 = Hospital Owner
   * 9  = Hospital Admin
   * 22 = Doctor
   */
  private getCurrentLoginRoleId(): number {
    // Full Login must stay Full Login for this layout session even when
    // Hospital role/dashboard context is selected internally.
    if (this.isFullLoginSession) {
      return 1;
    }

    const currentUser: any =
      this.User ||
      this.userLoginService.User();

    return Number(
      currentUser?.roleId ??
      currentUser?.RoleId ??
      0
    );
  }

  /**
   * Keep only actual visible menu mappings.
   *
   * IMPORTANT:
   * Your RoleId = 9 data contains old/deleted rows such as the previous
   * sr-billing / sr-appointment mappings together with the new active
   * hm-billing / hm-appointments mappings. Those legacy rows must never be
   * used for the left sidebar.
   */
  private isActiveHospitalMenuRecord(menu: any): boolean {
    const isActive = Number(
      menu?.isActive ??
      menu?.IsActive ??
      1
    );

    const isDeleted = Number(
      menu?.isDeleted ??
      menu?.IsDeleted ??
      0
    );

    return isActive === 1 && isDeleted === 0;
  }

  /**
   * Dashboard route is authoritative.
   * On child hospital pages we retain the most recently selected dashboard role.
   *
   * 32 = Hospital Owner
   * 9  = Hospital Admin
   * 22 = Doctor
   *
   * Full Login (RoleId = 1) enters the Hospital module using the Hospital Admin
   * sidebar by default. This matches the BO server menu shown in your screenshot.
   */
  private getActiveHospitalDashboardRoleId(): number {
    const currentRoute = this.normalizeHospitalDashboardRoute(
      window.location.pathname || this.router.url || "",
    );

    let routeRoleId = 0;

    if (currentRoute === "/hospital/hm-owner-dashboard") {
      routeRoleId = 32;
    } else if (currentRoute === "/hospital/hm-hospital-dashboard") {
      routeRoleId = 9;
    } else if (currentRoute === "/hospital/hm-d-dashboard") {
      routeRoleId = 22;
    }

    if (routeRoleId > 0) {
      sessionStorage.setItem(
        this.HOSPITAL_ACTIVE_DASHBOARD_ROLE_KEY,
        String(routeRoleId),
      );

      return routeRoleId;
    }

    const loginRoleId = this.getCurrentLoginRoleId();

    // Normal Hospital users must always use their actual role.
    if ([32, 9, 22].includes(loginRoleId)) {
      sessionStorage.setItem(
        this.HOSPITAL_ACTIVE_DASHBOARD_ROLE_KEY,
        String(loginRoleId),
      );

      return loginRoleId;
    }

    /*
     * Full Login can enter Hospital from the global module menu.
     * The legacy /hospital/hm-dashboard route must also open the Admin menu,
     * otherwise only the top-level Hospital item can remain visible.
     */
    if (
      loginRoleId === 1 &&
      (
        currentRoute === "/hospital" ||
        currentRoute === "/hospital/hm-dashboard"
      )
    ) {
      sessionStorage.setItem(
        this.HOSPITAL_ACTIVE_DASHBOARD_ROLE_KEY,
        "9",
      );

      return 9;
    }

    if (this.isHospitalModuleRoute()) {
      const storedRoleId = Number(
        sessionStorage.getItem(
          this.HOSPITAL_ACTIVE_DASHBOARD_ROLE_KEY,
        ) || 0,
      );

      if ([32, 9, 22].includes(storedRoleId)) {
        return storedRoleId;
      }

      // Full Login without an earlier dashboard selection defaults to Admin.
      if (loginRoleId === 1) {
        sessionStorage.setItem(
          this.HOSPITAL_ACTIVE_DASHBOARD_ROLE_KEY,
          "9",
        );

        return 9;
      }
    }

    return 0;
  }

  /**
   * Shows only the menu mapped to the dashboard role currently selected.
   * The original SubRoles_ReadByUserId result and menuList are not changed.
   *
   * MINIMUM FIX:
   * - Full Login uses the selected Hospital role menu directly. Do not intersect
   *   it with RoleId=1's global module menu, otherwise all Hospital children are
   *   removed and only the Hospital parent remains.
   * - Normal Hospital users still use ReadByUserId as the final source so your
   *   user-specific Hide/Show configuration continues to work.
   * - Deleted/inactive legacy mappings are ignored.
   */
  private applyHospitalDashboardSidebarMenu(): void {
    if (!this.allUserMenuItems.length) {
      return;
    }

    /*
     * CRITICAL FULL-LOGIN FIX:
     * For RoleId=1 this method must NOT rebuild/replace parentMenu during a
     * Hospital NavigationEnd. The Full Login MenuMaster tree is already the
     * authoritative global sidebar and must remain intact (BBPS, School,
     * Society, Hospital, etc.). Only normal Hospital users use the
     * role-specific filtering below.
     */
    if (this.isFullLoginSession) {
      ++this.hospitalMenuRequestId;

      // If the MenuMaster tree has not been loaded yet, start it once.
      if (
        !this.fullLoginMenuMasterItems.length &&
        !this.isFullLoginMenuMasterLoading
      ) {
        this.loadFullLoginMenuMaster();
      }

      // IMPORTANT: do not assign parentMenu here.
      // This preserves the complete global menu already rendered for Full Login.
      return;
    }

    const loginRoleId = this.getCurrentLoginRoleId();

    if (!this.isHospitalModuleRoute()) {
      ++this.hospitalMenuRequestId;
      this.parentMenu = this.buildMenuTree(this.getBaseSidebarMenuItems());
      return;
    }

    const activeRoleId = this.getActiveHospitalDashboardRoleId();

    if (![32, 9, 22].includes(activeRoleId)) {
      ++this.hospitalMenuRequestId;
      this.parentMenu = this.buildMenuTree(this.allUserMenuItems);
      return;
    }

    const requestId = ++this.hospitalMenuRequestId;

    this.subRolesService
      .SubRoles_readByRoleId({
        roleId: activeRoleId,
      } as any)
      .subscribe({
        next: (roleMenuResponse: any) => {
          if (requestId !== this.hospitalMenuRequestId) {
            return;
          }

          const roleMenuItems: any[] = Array.isArray(
            roleMenuResponse?.items,
          )
            ? roleMenuResponse.items
            : Array.isArray(roleMenuResponse)
            ? roleMenuResponse
            : [];

          // Remove old/deleted duplicate menu rows before building the sidebar.
          const activeRoleMenuItems = roleMenuItems.filter(
            (menu: any) => this.isActiveHospitalMenuRecord(menu),
          );

          const activeUserMenuItems = (
            this.allUserMenuItems as any[]
          ).filter((menu: any) =>
            this.isActiveHospitalMenuRecord(menu),
          );

          /*
           * Full Login exits above and keeps the global MenuMaster tree.
           * Normal Hospital users continue using ReadByUserId so user-specific
           * Hide/Show configuration remains exactly as before.
           */
          const sidebarSourceItems: any[] = activeUserMenuItems;

          const allowedMenuIds = new Set<number>(
            activeRoleMenuItems
              .map((item: any) =>
                Number(item?.menuId ?? item?.MenuId ?? 0),
              )
              .filter((menuId: number) => menuId > 0),
          );

          // Attendance candidates can come from either role mapping or the
          // user-specific mapping. Keep the old Owner/Admin rule unchanged.
          const attendanceMenus = [
            ...activeRoleMenuItems,
            ...activeUserMenuItems,
          ].filter((menu: any) =>
            this.isHospitalAttendanceManagementMenu(menu),
          );

          // OWNER: Attendance Management must be visible.
          if (activeRoleId === 32) {
            attendanceMenus.forEach((menu: any) => {
              const menuId = Number(
                menu?.menuId ?? menu?.MenuId ?? 0,
              );

              if (menuId > 0) {
                allowedMenuIds.add(menuId);
              }
            });
          }

          // ADMIN: Attendance Management must not be visible.
          if (activeRoleId === 9) {
            attendanceMenus.forEach((menu: any) => {
              const menuId = Number(
                menu?.menuId ?? menu?.MenuId ?? 0,
              );

              if (menuId > 0) {
                allowedMenuIds.delete(menuId);
              }
            });
          }

          if (!allowedMenuIds.size) {
            // Preserve existing working flow if role mapping API returns nothing.
            this.parentMenu = this.buildMenuTree(
              this.allUserMenuItems,
            );
            return;
          }

          // Include all parent menus needed by allowed child items.
          let parentAdded = true;

          while (parentAdded) {
            parentAdded = false;

            for (const menu of sidebarSourceItems as any[]) {
              const menuId = Number(
                menu?.menuId ?? menu?.MenuId ?? 0,
              );

              const parentMenuId = Number(
                menu?.parentMenuId ??
                  menu?.ParentMenuId ??
                  0,
              );

              if (
                menuId > 0 &&
                allowedMenuIds.has(menuId) &&
                parentMenuId > 0 &&
                !allowedMenuIds.has(parentMenuId)
              ) {
                allowedMenuIds.add(parentMenuId);
                parentAdded = true;
              }
            }
          }

          let visibleMenuItems = sidebarSourceItems.filter(
            (menu: any) =>
              allowedMenuIds.has(
                Number(menu?.menuId ?? menu?.MenuId ?? 0),
              ),
          );

          // Final UI-only safety rule after role filtering.
          // This guarantees Attendance Management cannot leak back into Admin.
          if (activeRoleId === 9) {
            visibleMenuItems = visibleMenuItems.filter(
              (menu: any) =>
                !this.isHospitalAttendanceManagementMenu(menu),
            );
          }

          // Owner safety rule: append Attendance if it exists in either active
          // source and was omitted by the role filtering response.
          if (activeRoleId === 32) {
            const currentIds = new Set(
              visibleMenuItems.map((menu: any) =>
                Number(menu?.menuId ?? menu?.MenuId ?? 0),
              ),
            );

            attendanceMenus.forEach((menu: any) => {
              const menuId = Number(
                menu?.menuId ?? menu?.MenuId ?? 0,
              );

              if (menuId > 0 && !currentIds.has(menuId)) {
                visibleMenuItems.push(menu);
                currentIds.add(menuId);
              }
            });
          }

          this.expandedMenus = {};
          this.parentMenu = this.buildMenuTree(visibleMenuItems);
          this.restoreSidebarScrollPosition();
        },
        error: (err: any) => {
          if (requestId !== this.hospitalMenuRequestId) {
            return;
          }

          console.error(
            "Error loading role-specific hospital sidebar:",
            err,
          );

          this.parentMenu = this.buildMenuTree(
            this.getBaseSidebarMenuItems(),
          );
          this.restoreSidebarScrollPosition();
        },
      });
  }

  /**
   * Hospital sidebar navigation must use the ACTIVE SubRoleCode instead of an
   * old MenuMaster TemplatePath.
   *
   * Example from your current data:
   *   Dashboard -> hm-hospital-dashboard
   *   Billing   -> hm-billing
   *
   * This prevents old paths such as /hospital/hm-dashboard and
   * /hospital/hm-hospital-detail?tab=hospital-billing from opening the wrong
   * component. Non-hospital menu navigation keeps the existing behavior.
   */
  getSidebarRouterLink(
  menu: any,
  parent?: any,
): string | any[] {

  const subRoleCode = String(
    menu?.subRoleCode ??
    menu?.SubRoleCode ??
    "",
  )
    .trim()
    .replace(/^\/+/, "");

  const parentSubRoleCode = String(
    parent?.subRoleCode ??
    parent?.SubRoleCode ??
    "",
  )
    .trim()
    .replace(/^\/+/, "");


  const normalizedCode = subRoleCode.toLowerCase();
  const normalizedParent = parentSubRoleCode.toLowerCase();


  // ==============================
  // HOSPITAL
  // ==============================
  if (
    normalizedCode === "hospital"
  ) {
    return "/hospital";
  }

  if (
    normalizedCode.startsWith("hm-") ||
    normalizedCode.startsWith("nurse-") ||
    normalizedCode === "other-staff-profile" ||
    normalizedParent === "hospital"
  ) {
    return `/hospital/${subRoleCode}`;
  }



  // // ==============================
  // // SCHOOL
  // // ==============================
  // if (
  //   normalizedParent === "school" ||
  //   normalizedParent === "school-admin"
  // ) {
  //   return `/school-admin/${subRoleCode}`;
  // }


  // if (
  //   normalizedCode.startsWith("spe-")
  // ) {
  //   return `/school-admin/${subRoleCode}`;
  // }
   
  
  // ==============================
  // SCHOOL
  // ==============================

  // School Fees and Feedback existing routes
  if (
    normalizedParent === "school" ||
    normalizedParent === "school-admin"
  ) {
    if (normalizedCode === "fees" || normalizedCode === "fee") {
      return "/fee";
    }

    if (normalizedCode === "feedback") {
      return "/feedback";
    }

    return `/school-admin/${subRoleCode}`;
  }



  // ==============================
  // SOCIETY
  // ==============================
  if (
    normalizedParent === "housing-society" ||
    normalizedParent === "society"
  ) {
    return `/housing-society/${subRoleCode}`;
  }


  if (
    normalizedCode.startsWith("sm-")
  ) {
    return `/housing-society/${subRoleCode}`;
  }



  // ==============================
  // EXISTING TEMPLATE PATH
  // ==============================
  const templatePath = String(
    menu?.templatePath ??
    menu?.TemplatePath ??
    "",
  ).trim();


  if (templatePath) {
    return templatePath;
  }


  // ==============================
  // FALLBACK
  // ==============================
  if (parent) {
    return [
      parentSubRoleCode,
      subRoleCode,
    ];
  }


  return subRoleCode;
}
  isSidebarParentMenuOpen(parent: any): boolean {
    const menuId = Number(parent?.menuId ?? parent?.MenuId ?? 0);

    // Preserve the existing manual collapse/expand state when the user clicks.
    if (menuId > 0 && this.expandedMenus[menuId] === true) {
      return true;
    }

    const subRoleCode = String(
      parent?.subRoleCode ??
      parent?.SubRoleCode ??
      "",
    )
      .trim()
      .toLowerCase();

    // Keep Hospital submenu open on every /hospital/... page.
    if (
      subRoleCode === "hospital" &&
      this.isHospitalModuleRoute()
    ) {
      return true;
    }

    const templatePath = String(
      parent?.templatePath ??
      parent?.TemplatePath ??
      subRoleCode ??
      "",
    ).trim();

    if (templatePath && this.isActiveMenu(templatePath)) {
      return true;
    }

    // Generic fix for School / Society / Real Estate / other modules:
    // keep the parent expanded whenever any child route is active.
    const childMenus = Array.isArray(parent?.childMenuList)
      ? parent.childMenuList
      : [];

    return childMenus.some((child: any) => {
      const childLink = this.getSidebarRouterLink(child, parent);
      const childPath = Array.isArray(childLink)
        ? childLink.join("/")
        : String(childLink || "");

      return !!childPath && this.isActiveMenu(childPath);
    });
  }

  /**
   * MINIMUM FIX: accordion behavior.
   * Only one parent submenu can be manually expanded at a time.
   * Existing route-based auto-open behavior remains unchanged.
   */
  toggleMenu(menuId: number): void {
    this.rememberSidebarScrollPosition();

    const wasAlreadyExpanded =
      this.expandedMenus[menuId] === true;

    // Close every previously opened parent menu first.
    this.expandedMenus = {};

    // Clicking a different parent opens only that parent.
    if (!wasAlreadyExpanded) {
      this.expandedMenus[menuId] = true;
    }

    this.restoreSidebarScrollPosition();
  }

  /**
   * Called before parent/child navigation so clicking a menu near the bottom
   * does not send the sidebar back to the top.
   */
  rememberSidebarScrollPosition(): void {
    const sidebarElement =
      this.sidebarMenuScroll?.nativeElement;

    if (!sidebarElement) {
      return;
    }

    this.sidebarMenuScrollTop =
      sidebarElement.scrollTop;

    sessionStorage.setItem(
      this.SIDEBAR_SCROLL_POSITION_KEY,
      String(this.sidebarMenuScrollTop)
    );
  }

  /**
   * Restore after Angular routing and Bootstrap collapse animation finish.
   */
  private restoreSidebarScrollPosition(): void {
    const savedValue = Number(
      sessionStorage.getItem(
        this.SIDEBAR_SCROLL_POSITION_KEY
      ) ?? this.sidebarMenuScrollTop
    );

    const scrollTop =
      Number.isFinite(savedValue) && savedValue >= 0
        ? savedValue
        : 0;

    this.sidebarMenuScrollTop = scrollTop;

    const restore = () => {
      const sidebarElement =
        this.sidebarMenuScroll?.nativeElement;

      if (sidebarElement) {
        sidebarElement.scrollTop = scrollTop;
      }
    };

    // First restore after Angular updates the view.
    setTimeout(restore, 0);

    // Restore once more after Bootstrap's collapse transition.
    setTimeout(restore, 380);
  }

  buildMenuTree(
    menuItems: SubRoleMenuDTO[],
    parentId: number = 0
  ): SubRoleMenuDTO[] {
    return menuItems
      .filter((menu) => menu.parentMenuId === parentId)
      .map((menu) => ({
        ...menu,
        childMenuList: this.buildMenuTree(menuItems, menu.menuId),
      }));
  }

  isActiveMenu(path: string): boolean {
    return this.router.url.includes(path);
  }

  logout(): void {
    // Clear only the Full Login persistence added for the current tab.
    // Existing logout flow remains unchanged.
    this.isFullLoginSession = false;
    sessionStorage.removeItem(this.FULL_LOGIN_SESSION_KEY);
    sessionStorage.removeItem(this.SIDEBAR_SCROLL_POSITION_KEY);
    this.userLoginService.SignOutUser();
  }

  openInNewTab(url: string): void {
    window.open(url, "_blank");
  }

  openSupport() {
    const currentUrl = this.router.url;

    let targetUrl = "";

    if (currentUrl.includes("/real-estate")) {
      targetUrl = "https://realestate.dev.vnccy.com";
    } else if (currentUrl.includes("/school")) {
      targetUrl = "https://school.dev.vnccy.com";
    } else if (currentUrl.includes("/hospital")) {
      targetUrl = "https://hospital.dev.vnccy.com";
    } else if (currentUrl.includes("/housing-society")) {
      targetUrl = "https://housingsociety.dev.vnccy.com";
    } else {
      targetUrl = "https://nishwik.dev.vnccy.com";
    }

    window.open(targetUrl, "_blank");
  }

  isSidebarCollapsed = false;
  isMobileSidebarOpen = false;

  toggleSidebar() {
    if (window.innerWidth > 991) {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    }
  }

  toggleMobileSidebar() {
    if (window.innerWidth <= 991) {
      this.isMobileSidebarOpen = !this.isMobileSidebarOpen;

      if (this.isMobileSidebarOpen) {
        this.isSidebarCollapsed = false;
      }
    }
  }

  private isHospitalModuleRoute(): boolean {
    const currentUrl = String(
      this.router.url ||
      window.location.pathname ||
      ""
    ).toLowerCase();

    return (
      currentUrl.includes("/hospital") ||
      currentUrl.includes("/hm-")
    );
  }

  onHospitalBrandLogoError(): void {
    this.hospitalBrandLogoFailed = true;
    this.hospitalBrandLogo = "";
  }

  private resetHospitalBrand(): void {
    this.hospitalBrandName = "";
    this.hospitalBrandLogo = "";
    this.hospitalBrandLogoFailed = false;
  }

  private loadHospitalBrandByHospitalId(hospitalId: number): void {
    if (!hospitalId) {
      this.resetHospitalBrand();
      return;
    }

    this.hospitalMasterService
      .HospitalMaster_ReadById({
        hospitalId: Number(hospitalId),
      })
      .subscribe({
        next: (res: any) => {
          const hospital =
            res?.items?.[0] ||
            res?.item ||
            res?.data?.[0] ||
            res?.data ||
            res;

          this.hospitalBrandName = String(
            hospital?.hospitalName ||
            hospital?.HospitalName ||
            hospital?.name ||
            hospital?.Name ||
            ""
          ).trim();

          this.loadHospitalLogoByHospitalId(hospitalId);
        },
        error: (err: any) => {
          console.error("Error fetching hospital name:", err);

          // Even if name API fails, still load hospital logo
          this.loadHospitalLogoByHospitalId(hospitalId);
        },
      });
  }

  private loadHospitalLogoByHospitalId(hospitalId: number): void {
    if (!hospitalId) {
      this.resetHospitalBrand();
      return;
    }

    const payload: HospitalImgMasterReadByMasterIdRequestDTO = {
      masterId: Number(hospitalId),
      masterType: "Hospital",
    };

    this.hospitalImgService
      .HospitalImgMaster_ReadByMasterId(payload)
      .subscribe({
        next: (res: any) => {
          const imageList = Array.isArray(res?.items)
            ? res.items
            : [];

          const defaultImage =
            imageList.find(
              (image: any) =>
                Number(image?.isDefault || image?.IsDefault || 0) === 1
            ) || imageList[0];

          const logoPath = String(
            defaultImage?.imgPath ||
            defaultImage?.ImgPath ||
            ""
          ).trim();

          if (!logoPath) {
            console.warn(
              "No default hospital image found for hospitalId:",
              hospitalId
            );

            this.hospitalBrandLogo = "";
            this.hospitalBrandLogoFailed = false;
            return;
          }

          this.hospitalBrandLogo =
            this.normalizeHospitalLogoUrl(logoPath);

          this.hospitalBrandLogoFailed = false;
        },
        error: (err: any) => {
          console.error("Error fetching hospital logo:", err);
          this.resetHospitalBrand();
        },
      });
  }

  private normalizeHospitalLogoUrl(logoPath: string): string {
    if (!logoPath) {
      return "";
    }

    const value = String(logoPath)
      .trim()
      .replace(/\\/g, "/");

    if (!value) {
      return "";
    }

    if (
      value.startsWith("http://") ||
      value.startsWith("https://") ||
      value.startsWith("data:image/")
    ) {
      return value;
    }

    if (value.startsWith("assets/") || value.startsWith("/assets/")) {
      return value;
    }

    const hospitalRootUrl = String(
      environment.hmApiURL || environment.apiURL || ""
    ).replace(/\/$/, "");

    if (!hospitalRootUrl) {
      return value;
    }

    if (value.startsWith("/")) {
      return `${hospitalRootUrl}${value}`;
    }

    return `${hospitalRootUrl}/${value}`;
  }

  private refreshHospitalLogo(): void {
    if (!this.isHospitalModuleRoute()) {
      this.resetHospitalBrand();
      return;
    }

    const userId = Number(this.User?.userId || 0);
    const routeHospitalId = this.getHospitalIdForBrand();

    if (!userId) {
      this.resetHospitalBrand();
      return;
    }

    const payload: HospitalUserAffiliationReadByUserIdRequestDTO = {
      userId: userId,
    };

    this.hospitalUserAffiliationService
      .HospitalUserAffiliationReadByUserId(payload)
      .subscribe({
        next: (res: any) => {
          const hospitalList = Array.isArray(res?.items)
            ? res.items
            : Array.isArray(res?.data)
            ? res.data
            : res?.item
            ? [res.item]
            : res?.data && typeof res.data === "object"
            ? [res.data]
            : [];

          const hospitalData =
            hospitalList.find((item: any) => {
              const itemHospitalId = Number(
                item?.hospitalId ||
                item?.HospitalId ||
                item?.masterId ||
                item?.MasterId ||
                0
              );

              return (
                routeHospitalId > 0 &&
                itemHospitalId === routeHospitalId
              );
            }) ||
            hospitalList[0] ||
            null;

          const hospitalId = Number(
            routeHospitalId ||
            hospitalData?.hospitalId ||
            hospitalData?.HospitalId ||
            hospitalData?.masterId ||
            hospitalData?.MasterId ||
            0
          );

          const nestedHospital =
            hospitalData?.hospital ||
            hospitalData?.Hospital ||
            hospitalData?.hospitalMaster ||
            hospitalData?.HospitalMaster ||
            hospitalData?.hospitalDetail ||
            hospitalData?.HospitalDetail ||
            hospitalData;

          const hospitalName = String(
            nestedHospital?.hospitalName ||
            nestedHospital?.HospitalName ||
            nestedHospital?.affiliationName ||
            nestedHospital?.AffiliationName ||
            nestedHospital?.institutionName ||
            nestedHospital?.InstitutionName ||
            nestedHospital?.organizationName ||
            nestedHospital?.OrganizationName ||
            nestedHospital?.companyName ||
            nestedHospital?.CompanyName ||
            nestedHospital?.name ||
            nestedHospital?.Name ||
            nestedHospital?.otherDetail1 ||
            nestedHospital?.OtherDetail1 ||
            ""
          ).trim();

          this.hospitalBrandName = hospitalName;

          if (!hospitalId) {
            console.warn(
              "Hospital affiliation does not contain hospitalId."
            );

            this.resetHospitalBrand();
            return;
          }

          this.loadHospitalBrandByHospitalId(hospitalId);
        },
        error: (err: any) => {
          console.error(
            "Error loading hospital affiliation for branding:",
            err
          );

          this.resetHospitalBrand();
        },
      });
  }

  private getHospitalIdForBrand(): number {
    let route: any = this.activatedRoute.snapshot;
    let hospitalId = 0;

    while (route) {
      const value =
        route.paramMap?.get("hospitalId") ||
        route.paramMap?.get("HospitalId") ||
        route.queryParamMap?.get("hospitalId") ||
        route.queryParamMap?.get("HospitalId");

      if (value && !isNaN(Number(value))) {
        hospitalId = Number(value);
      }

      route = route.firstChild;
    }

    if (hospitalId > 0) {
      return hospitalId;
    }

    const currentUrl = String(
      this.router.url ||
      window.location.pathname ||
      ""
    );

    const hospitalRouteMatch = currentUrl.match(
      /\/hospital\/(?:hospital-master|hm-hospital-detail|hm-hospital-opd|hm-re-opd|hm-hospital-ipd)\/(\d+)/i
    );

    if (hospitalRouteMatch?.[1]) {
      return Number(hospitalRouteMatch[1]);
    }

    const queryMatch = currentUrl.match(
      /[?&]hospitalId=(\d+)/i
    );

    if (queryMatch?.[1]) {
      return Number(queryMatch[1]);
    }

    return Number(
      this.User?.hospitalId ||
      this.User?.loggedInHospitalId ||
      localStorage.getItem("hospitalId") ||
      sessionStorage.getItem("hospitalId") ||
      0
    );
  }

  // ============================================================
  // MINIMUM ADDITION: ROUTE-BASED MULTI-MODULE CERTIFICATE METHODS
  // ============================================================

  openGenerateCertificatePopup(): void {
    /*
     * MINIMUM FIX:
     * No Module dropdown.
     *
     * Current route decides the module automatically:
     *   School route          -> School
     *   Hospital route        -> Hospital
     *   Housing Society route -> Society
     */
    const routeModule =
      this.getCertificateModuleFromCurrentRoute();

    if (!routeModule) {
      this.toastr.warning(
        "Certificate generation is available only for School, Hospital and Housing Society modules."
      );
      return;
    }

    this.certificateSelectedModuleName =
      routeModule;

    this.showGenerateCertificatePopup =
      true;

    this.selectedCertificateEntityId = 0;

    /*
     * Keep existing School variables synchronized.
     * Existing working flow/method names are not removed.
     */
    this.selectedCertificateSchoolId = 0;
    this.certificateSchoolList = [];

    this.certificateEntityList = [];

    this.certificateTemplateId = "";
    this.certificateTemplateList = [];

    this.certificateHeaderHtml = "";
    this.certificateCustomCss = "";
    this.certificateFooterHtml = "";

    this.generatedCertificateHtml = "";

    /*
     * Both dropdowns are API-driven.
     */
    this.loadCertificateEntityList();
    this.loadCertificateTemplateTypes();
  }

  closeGenerateCertificatePopup(): void {
    if (this.isCertificateGenerating) {
      return;
    }

    this.showGenerateCertificatePopup = false;
  }

  /*
   * Loads the correct onboarded institution list according to the
   * current module detected from the URL/menu.
   *
   * School:
   *   existing SchoolMaster_ReadAll API.
   *
   * Hospital:
   *   existing HospitalMaster_ReadAll API.
   *
   * Housing Society:
   *   existing /SOC/SOC/ReadAll API.
   */
  loadCertificateEntityList(): void {
    const moduleName =
      this.normalizeCertificateModuleName(
        this.certificateSelectedModuleName
      );

    if (!moduleName) {
      this.certificateEntityList = [];
      return;
    }

    if (this.isCertificateEntityLoading) {
      return;
    }

    this.isCertificateEntityLoading = true;

    /*
     * Keep original School loading variable synchronized
     * so no old binding/flow is broken.
     */
    this.isCertificateSchoolLoading =
      moduleName === "School";

    let request: any;

    if (moduleName === "School") {
      request =
        this.schoolMasterService
          .SchoolMaster_ReadAll();
    } else if (moduleName === "Hospital") {
      request =
        this.hospitalMasterService
          .HospitalMaster_ReadAll();
    } else {
      const societyReadAllUrl =
        `${String(
          environment.smApiURL || ""
        ).replace(/\/$/, "")}` +
        "/SOC/SOC/ReadAll";

      request =
        this.http.get<any>(
          societyReadAllUrl
        );
    }

    request.subscribe({
      next: (res: any) => {
        const allEntities =
          this.getResponseItems(res);

        const activeEntities =
          allEntities.filter(
            (entity: any) => {
              const isActive = Number(
                entity?.isActive ??
                entity?.IsActive ??
                1
              );

              const isDeleted = Number(
                entity?.isDeleted ??
                entity?.IsDeleted ??
                0
              );

              return (
                isActive === 1 &&
                isDeleted === 0
              );
            }
          );

        /*
         * Prefer completed/onboarded rows whenever that API provides
         * OnBoardingStatus. If the API does not expose the field,
         * preserve the active list instead of incorrectly returning empty.
         */
        const hasOnBoardingStatus =
          activeEntities.some(
            (entity: any) =>
              entity?.onBoardingStatus !==
                undefined ||
              entity?.OnBoardingStatus !==
                undefined
          );

        const onboardedEntities =
          activeEntities.filter(
            (entity: any) => {
              const status = String(
                entity?.onBoardingStatus ??
                entity?.OnBoardingStatus ??
                ""
              )
                .trim()
                .toLowerCase();

              return (
                status === "completed" ||
                status === "complete" ||
                status === "onboarded" ||
                status ===
                  "onboarding completed"
              );
            }
          );

        this.certificateEntityList =
          hasOnBoardingStatus &&
          onboardedEntities.length > 0
            ? onboardedEntities
            : activeEntities;

        /*
         * Keep previous School list state intact/synchronized.
         */
        this.certificateSchoolList =
          moduleName === "School"
            ? this.certificateEntityList
            : [];

        this.isCertificateEntityLoading =
          false;

        this.isCertificateSchoolLoading =
          false;

        if (
          this.certificateEntityList.length ===
          1
        ) {
          this.selectedCertificateEntityId =
            this.getCertificateEntityId(
              this.certificateEntityList[0]
            );

          if (moduleName === "School") {
            this.selectedCertificateSchoolId =
              this.selectedCertificateEntityId;
          }
        }
      },

      error: (err: any) => {
        console.error(
          "Certificate institution list load error:",
          err
        );

        this.certificateEntityList = [];
        this.certificateSchoolList = [];

        this.isCertificateEntityLoading =
          false;

        this.isCertificateSchoolLoading =
          false;

        this.toastr.error(
          `Unable to load ${this.certificateEntityLabel.toLowerCase()} list.`
        );
      },
    });
  }

  /*
   * Existing function retained exactly as a compatibility wrapper.
   * It is not used to change any current non-certificate flow.
   */
  loadCertificateSchoolList(): void {
    this.certificateSelectedModuleName =
      "School";

    this.loadCertificateEntityList();
  }

  /*
   * Template Type dropdown is loaded from each module's existing
   * PrintMaster API using the base template row ID = 0.
   *
   * School   -> /SCL/PM/ReadBySchoolId    { schoolId: 0 }
   * Hospital -> /H/PM/ReadByHospitalId    { hospitalId: 0 }
   * Society  -> /SOC/PM/ReadBySocietyId   { societyId: 0 }
   *
   * Dropdown displays MasterType because current dbo.GeneratePrint uses:
   *
   *     WHERE MasterType = @TemplateId
   */
  loadCertificateTemplateTypes(): void {
    const moduleName =
      this.normalizeCertificateModuleName(
        this.certificateSelectedModuleName
      );

    if (!moduleName) {
      this.certificateTemplateList = [];
      return;
    }

    if (this.isCertificateTemplateLoading) {
      return;
    }

    this.isCertificateTemplateLoading =
      true;

    this.certificateTemplateList = [];

    let request: any;

    if (moduleName === "School") {
      const templateUrl =
        `${String(
          environment.speApiURL || ""
        ).replace(/\/$/, "")}` +
        "/SCL/PM/ReadBySchoolId";

      request =
        this.http.post<any>(
          templateUrl,
          {
            schoolId: 0,
          }
        );
    } else if (moduleName === "Hospital") {
      const templateUrl =
        `${String(
          environment.hmApiURL || ""
        ).replace(/\/$/, "")}` +
        "/H/PM/ReadByHospitalId";

      request =
        this.http.post<any>(
          templateUrl,
          {
            hospitalId: 0,
          }
        );
    } else {
      const templateUrl =
        `${String(
          environment.smApiURL || ""
        ).replace(/\/$/, "")}` +
        "/SOC/PM/ReadBySocietyId";

      request =
        this.http.post<any>(
          templateUrl,
          {
            societyId: 0,
          }
        );
    }

    request.subscribe({
      next: (res: any) => {
        const uniqueTypes =
          new Set<string>();

        this.getResponseItems(res)
          .forEach((item: any) => {
            const masterType =
              String(
                item?.masterType ??
                item?.MasterType ??
                ""
              ).trim();

            const isActive = Number(
              item?.isActive ??
              item?.IsActive ??
              1
            );

            const isDeleted = Number(
              item?.isDeleted ??
              item?.IsDeleted ??
              0
            );

            if (
              masterType &&
              isActive === 1 &&
              isDeleted === 0
            ) {
              uniqueTypes.add(
                masterType
              );
            }
          });

        this.certificateTemplateList =
          Array.from(uniqueTypes).sort(
            (a, b) =>
              a.localeCompare(b)
          );

        /*
         * Small convenience only:
         * automatically select when exactly one API type exists.
         */
        if (
          this.certificateTemplateList
            .length === 1
        ) {
          this.certificateTemplateId =
            this
              .certificateTemplateList[0];
        }

        this.isCertificateTemplateLoading =
          false;
      },

      error: (err: any) => {
        console.error(
          "PrintMaster template type load error:",
          err
        );

        this.isCertificateTemplateLoading =
          false;

        this.certificateTemplateList = [];

        this.toastr.error(
          "Unable to load template types."
        );
      },
    });
  }

  /*
   * Existing School event handler retained.
   * Generic institution dropdown uses the same logic.
   */
  onCertificateSchoolChange(
    event: Event
  ): void {
    const selectElement =
      event.target as HTMLSelectElement;

    const entityId = Number(
      selectElement.value || 0
    );

    this.selectedCertificateEntityId =
      entityId;

    this.selectedCertificateSchoolId =
      this.certificateSelectedModuleName ===
      "School"
        ? entityId
        : 0;

    this.generatedCertificateHtml = "";
  }

  onCertificateEntityChange(
    event: Event
  ): void {
    this.onCertificateSchoolChange(
      event
    );
  }

  onCertificateTemplateChange(
    event: Event
  ): void {
    const selectElement =
      event.target as HTMLSelectElement;

    this.certificateTemplateId =
      String(
        selectElement.value || ""
      ).trim();

    this.generatedCertificateHtml = "";
  }

  /*
   * Existing function name is retained so current template flow does not break.
   * It now generates for the route-selected School/Hospital/Society module.
   */
  generateSchoolCertificate(): void {
    if (this.isCertificateGenerating) {
      return;
    }

    const moduleName =
      this.normalizeCertificateModuleName(
        this.certificateSelectedModuleName
      );

    if (!moduleName) {
      this.toastr.warning(
        "Unable to identify the current module."
      );
      return;
    }

    const moduleId = Number(
      this.selectedCertificateEntityId ||
      0
    );

    if (moduleId <= 0) {
      this.toastr.warning(
        `Please select a ${this.certificateEntityLabel.toLowerCase()}.`
      );
      return;
    }

    const templateId =
      String(
        this.certificateTemplateId ||
        ""
      ).trim();

    if (!templateId) {
      this.toastr.warning(
        "Please select a Template Type."
      );
      return;
    }

    this.isCertificateGenerating =
      true;

    this.generatedCertificateHtml = "";

    /*
     * Correct GeneratePrint payload.
     *
     * moduleName = route module.
     * moduleId   = actual selected SchoolId/HospitalId/SocietyId.
     * templateId = selected API MasterType.
     */
    const generatePrintPayload:
      PrintMasterGeneratePrintRequestDTO =
      {
        moduleName: moduleName,

        /*
         * Backend DTO:
         * public string ModuleId { get; set; }
         */
        moduleId:
          moduleId.toString(),

        /*
         * Backend DTO marks these fields nullable.
         * Send null when the optional editor field is empty instead of
         * forcing an empty string.
         */
        templateId:
          templateId || null,

        headerHtml:
          this.certificateHeaderHtml
            ?.trim()
            ? this.certificateHeaderHtml
            : null,

        customCss:
          this.certificateCustomCss
            ?.trim()
            ? this.certificateCustomCss
            : null,

        footerHtml:
          this.certificateFooterHtml
            ?.trim()
            ? this.certificateFooterHtml
            : null,
      };

    console.log(
      "GeneratePrint Payload:",
      generatePrintPayload
    );

    const generatePrintUrl =
      `${String(
        environment.apiURL || ""
      ).replace(/\/$/, "")}` +
      "/M/PRT/GeneratePrint";

    /*
     * The existing encryption interceptor continues to handle
     * request/response encryption. No manual double encryption is added.
     */
    this.http
      .post<PrintMasterGeneratePrintList>(
        generatePrintUrl,
        generatePrintPayload
      )
      .subscribe({
        next: (
          generateRes:
            PrintMasterGeneratePrintList
        ) => {
          let generatedTemplateSql =
            this.getGeneratePrintPContent(
              generateRes
            );

          if (
            !generatedTemplateSql?.trim()
          ) {
            this.isCertificateGenerating =
              false;

            this.toastr.error(
              "GeneratePrint API did not return PContent."
            );
            return;
          }

          /*
           * Resolve selected module/entity tokens before the existing
           * PrintDynamicSQL final render.
           */
          generatedTemplateSql =
            this.applyCertificateModuleTokens(
              generatedTemplateSql
            );

          const renderPayload:
            PrintMasterPrintDynamicSQLRequestDTO =
            {
              dynamicSQL:
                generatedTemplateSql,
            };

          this.masterPrintMasterService
            .PrintMaster_PrintDynamicSQL(
              renderPayload
            )
            .subscribe({
              next: (
                renderRes: any
              ) => {
                const responseHTML =
                  this.getCertificatePrintHtml(
                    renderRes
                  );

                const finalHtml =
                  this.convertCertificateToNormalHtml(
                    responseHTML
                  );

                this.isCertificateGenerating =
                  false;

                if (
                  !finalHtml?.trim()
                ) {
                  this.toastr.error(
                    "Unable to generate certificate."
                  );
                  return;
                }

                this.generatedCertificateHtml =
                  finalHtml;

                this.toastr.success(
                  "Certificate generated successfully."
                );
              },

              error: (
                renderError: any
              ) => {
                console.error(
                  "Certificate PrintDynamicSQL render error:",
                  renderError
                );

                this.isCertificateGenerating =
                  false;

                this.toastr.error(
                  renderError?.error
                    ?.message ||
                  renderError?.error
                    ?.Message ||
                  renderError?.message ||
                  "Unable to render certificate."
                );
              },
            });
        },

        error: (
          generateError: any
        ) => {
          console.error(
            "GeneratePrint API error:",
            generateError
          );

          this.isCertificateGenerating =
            false;

          this.toastr.error(
            generateError?.error
              ?.message ||
            generateError?.error
              ?.Message ||
            generateError?.error ||
            generateError?.message ||
            "Unable to generate certificate template."
          );
        },
      });
  }

  private getGeneratePrintPContent(
    response: any
  ): string {
    const items =
      this.getResponseItems(response);

    if (!items.length) {
      return "";
    }

    for (const item of items) {
      const pContent =
        String(
          item?.pContent ??
          item?.PContent ??
          item?.htmlData ??
          item?.HtmlData ??
          ""
        );

      if (pContent.trim()) {
        return pContent;
      }
    }

    return "";
  }

  private getCertificatePrintHtml(
    response: any
  ): string {
    if (!response) {
      return "";
    }

    const items =
      Array.isArray(response?.items)
        ? response.items
        : Array.isArray(
            response?.Items
          )
        ? response.Items
        : Array.isArray(response)
        ? response
        : [];

    return items
      .map((item: any) =>
        String(
          item?.htmlData ??
          item?.HtmlData ??
          item?.pContent ??
          item?.PContent ??
          ""
        )
      )
      .join("");
  }

  /*
   * Generic module token replacement.
   */
  private applyCertificateModuleTokens(
    templateSql: string
  ): string {
    if (!templateSql) {
      return "";
    }

    const moduleName =
      this.normalizeCertificateModuleName(
        this.certificateSelectedModuleName
      );

    const entity =
      this.getSelectedCertificateEntity();

    const moduleId =
      Number(
        this.selectedCertificateEntityId ||
        this.getCertificateEntityId(
          entity
        ) ||
        0
      );

    const entityName =
      this.prepareCertificateTokenText(
        this.getCertificateEntityName(
          entity
        )
      );

    const address =
      this.prepareCertificateTokenText(
        entity?.address ??
        entity?.Address ??
        ""
      );

    const city =
      this.prepareCertificateTokenText(
        entity?.city ??
        entity?.City ??
        ""
      );

    const state =
      this.prepareCertificateTokenText(
        entity?.state ??
        entity?.State ??
        ""
      );

    const country =
      this.prepareCertificateTokenText(
        entity?.country ??
        entity?.Country ??
        ""
      );

    const pincode =
      this.prepareCertificateTokenText(
        entity?.pincode ??
        entity?.Pincode ??
        entity?.zipCode ??
        entity?.ZipCode ??
        ""
      );

    const phoneNo =
      this.prepareCertificateTokenText(
        entity?.phoneNo ??
        entity?.PhoneNo ??
        entity?.contactPhone ??
        entity?.ContactPhone ??
        entity?.contactNumber ??
        entity?.ContactNumber ??
        ""
      );

    const email =
      this.prepareCertificateTokenText(
        entity?.email ??
        entity?.Email ??
        entity?.contactEmail ??
        entity?.ContactEmail ??
        ""
      );

    const replacements:
      Array<[RegExp, string]> = [
        [
          /{{ModuleName}}/g,
          moduleName,
        ],
        [
          /{{ModuleId}}/g,
          moduleId.toString(),
        ],
        [
          /{{MasterId}}/g,
          moduleId.toString(),
        ],

        [
          /{{SchoolId}}/g,
          moduleName === "School"
            ? moduleId.toString()
            : "",
        ],
        [
          /{{HospitalId}}/g,
          moduleName === "Hospital"
            ? moduleId.toString()
            : "",
        ],
        [
          /{{SocietyId}}/g,
          moduleName === "Society"
            ? moduleId.toString()
            : "",
        ],

        [
          /{{SchoolName}}/g,
          moduleName === "School"
            ? entityName
            : "",
        ],
        [
          /{{HospitalName}}/g,
          moduleName === "Hospital"
            ? entityName
            : "",
        ],
        [
          /{{SocietyName}}/g,
          moduleName === "Society"
            ? entityName
            : "",
        ],
        [
          /{{MasterName}}/g,
          entityName,
        ],

        [
          /{{SchoolAddress}}/g,
          moduleName === "School"
            ? address
            : "",
        ],
        [
          /{{HospitalAddress}}/g,
          moduleName === "Hospital"
            ? address
            : "",
        ],
        [
          /{{SocietyAddress}}/g,
          moduleName === "Society"
            ? address
            : "",
        ],
        [
          /{{Address}}/g,
          address,
        ],

        [/{{City}}/g, city],
        [/{{State}}/g, state],
        [/{{Country}}/g, country],

        [/{{Pincode}}/g, pincode],
        [/{{ZipCode}}/g, pincode],

        [/{{PhoneNo}}/g, phoneNo],
        [
          /{{ContactPhone}}/g,
          phoneNo,
        ],
        [
          /{{ContactNumber}}/g,
          phoneNo,
        ],

        [/{{Email}}/g, email],
        [
          /{{ContactEmail}}/g,
          email,
        ],
      ];

    let finalTemplate =
      templateSql;

    replacements.forEach(
      ([pattern, value]) => {
        finalTemplate =
          finalTemplate.replace(
            pattern,
            value
          );
      }
    );

    return finalTemplate;
  }

  /*
   * Existing helper retained for compatibility.
   */
  private applyCertificateSchoolTokens(
    templateSql: string
  ): string {
    return this.applyCertificateModuleTokens(
      templateSql
    );
  }

  private prepareCertificateTokenText(
    value: any
  ): string {
    if (
      value === null ||
      value === undefined
    ) {
      return "";
    }

    /*
     * PContent is SQL text.
     * Escape apostrophes for final PrintDynamicSQL execution.
     */
    return String(value).replace(
      /'/g,
      "''"
    );
  }

  private getSelectedCertificateEntity(): any {
    const entityId =
      Number(
        this.selectedCertificateEntityId ||
        0
      );

    return (
      this.certificateEntityList.find(
        (entity: any) =>
          this.getCertificateEntityId(
            entity
          ) === entityId
      ) || null
    );
  }

  /*
   * Existing helper retained.
   */
  private getSelectedCertificateSchool(): any {
    if (
      this.certificateSelectedModuleName !==
      "School"
    ) {
      return null;
    }

    return this.getSelectedCertificateEntity();
  }

  get certificateEntityLabel(): string {
    const moduleName =
      this.normalizeCertificateModuleName(
        this.certificateSelectedModuleName
      );

    if (moduleName === "Hospital") {
      return "Hospital";
    }

    if (moduleName === "Society") {
      return "Housing Society";
    }

    return "School";
  }

  get certificateBaseTemplateIdLabel(): string {
    const moduleName =
      this.normalizeCertificateModuleName(
        this.certificateSelectedModuleName
      );

    if (moduleName === "Hospital") {
      return "HospitalId 0";
    }

    if (moduleName === "Society") {
      return "SocietyId 0";
    }

    return "SchoolId 0";
  }

  get certificatePopupTitle(): string {
    return `Generate ${this.certificateEntityLabel} Certificate`;
  }

  get certificatePopupDescription(): string {
    return `Select ${this.certificateEntityLabel.toLowerCase()} and template type.`;
  }

  get certificateHeaderPlaceholderForSelectedModule(): string {
    const moduleName =
      this.normalizeCertificateModuleName(
        this.certificateSelectedModuleName
      );

    if (moduleName === "Hospital") {
      return (
        '<div class="certificate-header">\n' +
        '  <h2>{{HospitalName}}</h2>\n' +
        '  <p>{{HospitalAddress}}, {{City}}, {{State}}</p>\n' +
        '</div>'
      );
    }

    if (moduleName === "Society") {
      return (
        '<div class="certificate-header">\n' +
        '  <h2>{{SocietyName}}</h2>\n' +
        '  <p>{{SocietyAddress}}, {{City}}, {{State}} - {{ZipCode}}</p>\n' +
        '</div>'
      );
    }

    return this.certificateHeaderPlaceholder;
  }

  private getCertificateEntityId(
    entity: any
  ): number {
    const moduleName =
      this.normalizeCertificateModuleName(
        this.certificateSelectedModuleName
      );

    if (moduleName === "Hospital") {
      return Number(
        entity?.hospitalId ??
        entity?.HospitalId ??
        0
      );
    }

    if (moduleName === "Society") {
      return Number(
        entity?.societyId ??
        entity?.SocietyId ??
        0
      );
    }

    return Number(
      entity?.schoolId ??
      entity?.SchoolId ??
      0
    );
  }

  getCertificateEntityName(
    entity: any
  ): string {
    const moduleName =
      this.normalizeCertificateModuleName(
        this.certificateSelectedModuleName
      );

    if (moduleName === "Hospital") {
      return String(
        entity?.hospitalName ??
        entity?.HospitalName ??
        ""
      ).trim();
    }

    if (moduleName === "Society") {
      return String(
        entity?.societyName ??
        entity?.SocietyName ??
        ""
      ).trim();
    }

    return String(
      entity?.schoolName ??
      entity?.SchoolName ??
      ""
    ).trim();
  }

  getCertificateEntityValue(
    entity: any
  ): number {
    return this.getCertificateEntityId(
      entity
    );
  }

  private normalizeCertificateModuleName(
    value: any
  ): string {
    const normalized =
      String(value || "")
        .trim()
        .toLowerCase()
        .replace(
          /[\s_-]+/g,
          ""
        );

    if (
      normalized === "school" ||
      normalized === "spe" ||
      normalized.includes("school")
    ) {
      return "School";
    }

    if (
      normalized === "hospital" ||
      normalized === "hm" ||
      normalized.includes("hospital")
    ) {
      return "Hospital";
    }

    if (
      normalized === "society" ||
      normalized === "sm" ||
      normalized ===
        "housingsociety" ||
      normalized.includes("society")
    ) {
      return "Society";
    }

    return "";
  }

  /*
   * This is the only module selector now.
   * It is automatic and follows the route/menu that the user opened.
   */
  private getCertificateModuleFromCurrentRoute(): string {
    const currentUrl =
      String(
        this.router.url ||
        window.location.pathname ||
        ""
      )
        .split("?")[0]
        .split("#")[0]
        .trim()
        .toLowerCase();

    if (
      currentUrl.includes(
        "/hospital"
      ) ||
      currentUrl.includes("/hm-")
    ) {
      return "Hospital";
    }

    if (
      currentUrl.includes(
        "/housing-society"
      ) ||
      currentUrl.includes(
        "/society"
      ) ||
      currentUrl.includes("/sm-")
    ) {
      return "Society";
    }

    if (
      currentUrl.includes("/school") ||
      currentUrl.includes(
        "/school-admin"
      ) ||
      currentUrl.includes("/spe-")
    ) {
      return "School";
    }

    return "";
  }

  private convertCertificateToNormalHtml(
    escapedHtml:
      | string
      | null
      | undefined
  ): string {
    if (!escapedHtml) {
      return "";
    }

    let normalHtml =
      escapedHtml
        .replace(
          /\\r\\n/g,
          "\n"
        )
        .replace(
          /\\n/g,
          "\n"
        )
        .replace(
          /\\t/g,
          "\t"
        )
        .replace(
          /\\"/g,
          '"'
        );

    normalHtml =
      normalHtml.replace(
        /\\/g,
        ""
      );

    return normalHtml.trim();
  }

  private buildCertificatePreviewDocument(
    certificateHtml: string
  ): string {
    const baseTag =
      `<base href="${window.location.origin}/">`;

    if (
      /<head[^>]*>/i.test(
        certificateHtml
      )
    ) {
      return certificateHtml.replace(
        /<head([^>]*)>/i,
        `<head$1>${baseTag}`
      );
    }

    const title =
      `${this.certificateEntityLabel} ${this.certificateTemplateId || "Certificate"}`;

    return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  ${baseTag}
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1"
  >
  <title>${title}</title>
</head>
<body>
  ${certificateHtml}
</body>
</html>
`;
  }

  viewGeneratedSchoolCertificate(): void {
    if (
      !this.generatedCertificateHtml
        ?.trim()
    ) {
      this.toastr.warning(
        "Please generate the certificate first."
      );
      return;
    }

    const finalHtml =
      this.buildCertificatePreviewDocument(
        this
          .generatedCertificateHtml
      );

    const blob =
      new Blob(
        [finalHtml],
        {
          type:
            "text/html;charset=utf-8",
        }
      );

    const url =
      URL.createObjectURL(
        blob
      );

    const newWindow =
      window.open(
        url,
        "_blank",
        "noopener,noreferrer"
      );

    if (!newWindow) {
      URL.revokeObjectURL(
        url
      );

      this.toastr.warning(
        "Please allow popups to view the certificate."
      );
      return;
    }

    setTimeout(() => {
      URL.revokeObjectURL(
        url
      );
    }, 60000);
  }

  downloadGeneratedSchoolCertificate(): void {
    if (
      !this.generatedCertificateHtml
        ?.trim()
    ) {
      this.toastr.warning(
        "Please generate the certificate first."
      );
      return;
    }

    const finalHtml =
      this.buildCertificatePreviewDocument(
        this
          .generatedCertificateHtml
      );

    const blob =
      new Blob(
        [finalHtml],
        {
          type:
            "text/html;charset=utf-8",
        }
      );

    const url =
      URL.createObjectURL(
        blob
      );

    const anchor =
      document.createElement(
        "a"
      );

    const entityName =
      this.getSelectedCertificateEntityName();

    anchor.href = url;

    anchor.download =
      `${
        this.toCertificateSafeFileName(
          entityName ||
          this.certificateEntityLabel
        )
      }-${this.toCertificateSafeFileName(
        this.certificateTemplateId ||
        "Certificate"
      )}.html`;

    document.body.appendChild(
      anchor
    );

    anchor.click();

    document.body.removeChild(
      anchor
    );

    URL.revokeObjectURL(
      url
    );
  }

  private getSelectedCertificateEntityName(): string {
    return this.getCertificateEntityName(
      this.getSelectedCertificateEntity()
    );
  }

  /*
   * Existing School helper retained for compatibility.
   */
  private getSelectedCertificateSchoolName(): string {
    if (
      this.certificateSelectedModuleName !==
      "School"
    ) {
      return "";
    }

    return this.getSelectedCertificateEntityName();
  }

  private toCertificateSafeFileName(
    value: string
  ): string {
    return (
      String(
        value || "Certificate"
      )
        .trim()
        .replace(
          /[^a-zA-Z0-9-_]+/g,
          "-"
        )
        .replace(
          /-+/g,
          "-"
        )
        .replace(
          /^-|-$/g,
          ""
        ) || "Certificate"
    );
  }

}
